import DonutChart from '../generic/Charts/DonutChart';
import type { Props as StaticDonutProps } from '../generic/Charts/DonutChart';

import Error from './Error';
import Loading from './Loading';

/**
 * Props for a DonutMetricFacet
 */
export type Props = StaticDonutProps & {
  /**
   * If true, shows the loader component instead of the chart
   */
  isLoading?: boolean;
  /**
   * If true, shows an error message instead of the chart
   */
  error?: string;
};

/**
 * DonutMetricFacet component.
 *
 * This component represents a donut chart combined with a metric facet.
 * It displays a donut chart with a label, total value, and data.
 * It also handles loading and error states.
 */
const DonutMetricFacet = ({
  label,
  total,
  data,
  size,
  other,
  backgroundFill,
  startAngle,
  endAngle,
  innerRadius,
  outerRadius,
  paddingAngle,
  strokeWidth,
  isLoading,
  error,
}: Props) => {
  if (error) {
    return <Error label={label} message={error} />;
  }
  if (isLoading) {
    return <Loading />;
  }
  return (
    <DonutChart
      label={label}
      total={total}
      data={data}
      size={size}
      other={other}
      backgroundFill={backgroundFill}
      startAngle={startAngle}
      endAngle={endAngle}
      innerRadius={innerRadius}
      outerRadius={outerRadius}
      paddingAngle={paddingAngle}
      strokeWidth={strokeWidth}
    />
  );
};

export default DonutMetricFacet;
